<template>
  <div>
    <div id="entirety">
      <div id="headNav">
        <h6 class="head_text" @click="isCollapse = !isCollapse">傲举招聘管理系统</h6>
        <div style="margin-right: 4%">
          <div style="display: flex; width: 100%" @click="partserch(), IsConterShow = true;">
            <el-dropdown>
              <el-badge :value="readNUm" :max="99" class="item">
                <el-button type="text" icon="el-icon-message-solid" size="mini"
                  style=" font-size: 25px;color: white;top: -15px;position: relative;"></el-button>
              </el-badge>
              <el-dropdown-menu slot="dropdown" style="max-height: 300px;" class="scrollHidden">
                <el-dropdown-item v-if="tableData.length == 0">现在还有收到通知</el-dropdown-item>
                <!-- <div v-for="(item, index) in tableData" :key="index">

                  <el-dropdown-item :command="item.noticeId" style="position: relative;padding: 10px 25px 5px;">
                    <p style="display: inline-block;vertical-align: middle;" @click="getRead(item)">{{
                      item.noticeContent }}</p>
                    <el-button type="text" icon="el-icon-close" size="mini"
                      style="position: absolute;right: 0;top: -8px;color: red;"
                      @click="deleteRead(item.noticeId)"></el-button>
                    <p v-if="item.noticeStatus == 1"
                      style="width: 8px;height: 8px;background-color: red;border-radius: 100%;display: inline-block;vertical-align:middle;margin-left: 10px;">
                    </p>
                  </el-dropdown-item>
                </div> -->

              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown @command="handleCommand" style="color: white;font-size: 19px;">
              <span class="el-dropdown-link">
                {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">退出登录</el-dropdown-item>
                <el-dropdown-item command="b">修改密码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

      <div style="display: flex; width: 100%; height: calc(100% - 60px)">
        <div id="sideNav" class="scrollHidden" v-if="!flagShow">
          <el-menu :default-active="$route.name" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
            active-text-color="#0055ff" background-color="#121212" text-color="#fff" router :collapse="isCollapse"
            unique-opened>
            <el-menu-item index="userList" route="/Home/userList" v-if="iuPost == 2">
              <i class="el-icon-user-solid"></i>
              <span slot="title">用户管理</span>
            </el-menu-item>

            <el-menu-item index="recording" route="/Home/recording" v-if="iuPost != 3 && iuPost != 4">
              <i class="el-icon-info"></i>
              <span slot="title">录音管理</span>
            </el-menu-item>
            <el-submenu index="2" v-if="iuPost != 4">
              <template slot="title">
                <i class="el-icon-office-building"></i>
                <span>招聘管理</span>
              </template>
              <el-menu-item index="recruitmentAnalysis" route="/Home/recruitmentAnalysis"
                v-if="iuPost != 3 && iuPost != 4">
                <i class="el-icon-postcard"></i>
                <span slot="title">招聘分析</span>
              </el-menu-item>
              <el-menu-item index="applicant" route="/Home/applicant" v-if="iuPost != 3 && iuPost != 4">
                <i class="el-icon-postcard"></i>
                <span slot="title">面试管理</span>
              </el-menu-item>
              <el-menu-item index="applicantTwo" route="/Home/applicantTwo" v-if="iuPost == 3">
                <i class="el-icon-postcard"></i>
                <span slot="title">面试管理</span>
              </el-menu-item>
              <el-menu-item index="onlineInterView" route="/Home/onlineInterView" v-if="iuPost != 3 && iuPost != 4">
                <i class="el-icon-postcard"></i>
                <span slot="title">线上面试</span>
              </el-menu-item>
              <el-menu-item index="phoneModeList" route="/Home/phoneModeList" v-if="iuPost == 2">
                <i class="el-icon-tickets"></i>
                <span slot="title">手机型号库</span>
              </el-menu-item>
              <el-menu-item index="talentPool" route="/Home/talentPool" v-if="iuPost != 3 && iuPost != 4">
                <i class="el-icon-postcard"></i>
                <span slot="title">人才库</span>
              </el-menu-item>
              <el-menu-item index="channel" route="/Home/channel" v-if="iuPost == 2">
                <i class="el-icon-postcard"></i>
                <span slot="title">招聘渠道</span>
              </el-menu-item>

              <el-menu-item index="dateWeek" route="/Home/dateWeek" v-if="iuPost == 2">
                <i class="el-icon-postcard"></i>
                <span slot="title">统计周时间段</span>
              </el-menu-item>
              <el-menu-item index="Roster" route="/Home/Roster" v-if="iuPost != 3 && iuPost != 4">
                <i class="el-icon-postcard"></i>
                <span slot="title">花名册</span>
              </el-menu-item>
              <el-menu-item index="corporateAssets" route="/Home/corporateAssets" v-if="iuPost != 3 && iuPost != 4">
                <i class="el-icon-postcard"></i>
                <span slot="title">资产管理</span>
              </el-menu-item>
              <el-menu-item index="AssetsRoster" route="/Home/AssetsRoster" v-if="iuPost != 3 && iuPost != 4">
                <i class="el-icon-postcard"></i>
                <span slot="title">资产借用记录</span>
              </el-menu-item>
              <el-menu-item index="manualRecord" route="/Home/manualRecord" v-if="iuPost != 3 && iuPost != 4">
                <i class="el-icon-postcard"></i>
                <span slot="title">手册领用记录</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="personalityTest" route="/Home/personalityTest" v-if="iuPost != 3 && iuPost != 4">
              <i class="el-icon-postcard"></i>
              <span slot="title">测试管理</span>
            </el-menu-item>
            <el-menu-item index="BackTone" route="/Home/BackTone" v-if="iuPost == 2 || iuPost == 4 || iuPost == 3">
              <i class="el-icon-postcard"></i>
              <span slot="title">背调管理</span>
            </el-menu-item>
            <el-submenu index="3" v-if="iuPost == 2">
              <template slot="title">
                <i class="el-icon-tickets"></i>
                <span>试题管理</span>
              </template>
              <el-menu-item index="videoList" route="/Home/videoList">
                <i class="el-icon-tickets"></i>
                <span slot="title">视频库</span>
              </el-menu-item>

              <el-menu-item index="postList" route="/Home/postList">
                <i class="el-icon-tickets"></i>
                <span slot="title">岗位管理</span>
              </el-menu-item>
              <el-menu-item index="onlineDes" route="/Home/onlineDes">
                <i class="el-icon-tickets"></i>
                <span slot="title">线上简介</span>
              </el-menu-item>
              <el-menu-item index="topicAnswer" route="/Home/topicAnswer">
                <i class="el-icon-tickets"></i>
                <span slot="title">题库管理</span>
              </el-menu-item>
              <el-menu-item index="newTopicAnswer" route="/Home/newTopicAnswer">
                <i class="el-icon-postcard"></i>
                <span slot="title">试题分类</span>
              </el-menu-item>
              <el-menu-item index="TestGrouping" route="/Home/TestGrouping">
                <i class="el-icon-postcard"></i>
                <span slot="title">试题分组</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="8" v-if="iuPost == 2 && iuId == 4">
              <template slot="title">
                <i class="el-icon-s-platform"></i>
                <span>钉钉信息</span>
              </template>
              <el-menu-item index="DDingDepartment" route="/Home/DDingDepartment">
                <i class="el-icon-monitor"></i>
                <span slot="title">钉钉部门</span>
              </el-menu-item>
              <el-menu-item index="DDingUser" route="/Home/DDingUser">
                <i class="el-icon-monitor"></i>
                <span slot="title">钉钉用户</span>
              </el-menu-item>
              <el-menu-item index="DDingLeave" route="/Home/DDingLeave">
                <i class="el-icon-monitor"></i>
                <span slot="title">请假记录</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="5" v-if="iuPost == 2 && iuId == 4">
              <template slot="title">
                <i class="el-icon-s-platform"></i>
                <span>纷享销客</span>
              </template>
              <el-menu-item index="ShareCustomersToken" route="/Home/ShareCustomersToken">
                <i class="el-icon-monitor"></i>
                <span slot="title">Token记录</span>
              </el-menu-item>
              <el-menu-item index="ShareCustomersSj" route="/Home/ShareCustomersSj">
                <i class="el-icon-suitcase"></i>
                <span slot="title">商机记录</span>
              </el-menu-item>
              <el-menu-item index="ShareCustomersZc" route="/Home/ShareCustomersZc">
                <i class="el-icon-suitcase"></i>
                <span slot="title">内部支撑记录</span>
              </el-menu-item>
              <el-menu-item index="ShareCustomersXcb" route="/Home/ShareCustomersXcb">
                <i class="el-icon-suitcase"></i>
                <span slot="title">行程表记录</span>
              </el-menu-item>
              <el-menu-item index="ShareCustomersNQ" route="/Home/ShareCustomersNQ">
                <i class="el-icon-suitcase"></i>
                <span slot="title">行程表内勤</span>
              </el-menu-item>
              <el-menu-item index="ShareCustomersFileList" route="/Home/ShareCustomersFileList">
                <i class="el-icon-suitcase"></i>
                <span slot="title">文件列表</span>
              </el-menu-item>
              <el-menu-item index="colorWarehouse" route="/Home/colorWarehouse">
                <i class="el-icon-suitcase"></i>
                <span slot="title">颜色库</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="6" v-if="iuPost == 2 && iuId == 4">
              <template slot="title">
                <i class="el-icon-s-platform"></i>
                <span>纷享每刻在途</span>
              </template>
              <el-menu-item index="ShareCustomersDepartment" route="/Home/ShareCustomersDepartment">
                <i class="el-icon-monitor"></i>
                <span slot="title">部门列表</span>
              </el-menu-item>
              <el-menu-item index="ShareCustomersUser" route="/Home/ShareCustomersUser">
                <i class="el-icon-monitor"></i>
                <span slot="title">用户列表</span>
              </el-menu-item>
              <el-menu-item index="ShareCustomersTeacher" route="/Home/ShareCustomersTeacher">
                <i class="el-icon-monitor"></i>
                <span slot="title">讲师列表</span>
              </el-menu-item>
              <el-menu-item index="ShareCustomersMK" route="/Home/ShareCustomersMK">
                <i class="el-icon-suitcase"></i>
                <span slot="title">行程表每刻</span>
              </el-menu-item>
              <el-menu-item index="ztxcTs" route="/Home/ztxcTs">
                <i class="el-icon-suitcase"></i>
                <span slot="title">在途行程推送记录</span>
              </el-menu-item>
              <el-menu-item index="expenseAccountMK" route="/Home/expenseAccountMK">
                <i class="el-icon-suitcase"></i>
                <span slot="title">每刻报销单记录</span>
              </el-menu-item>
              <el-menu-item index="expenseSupplier" route="/Home/expenseSupplier">
                <i class="el-icon-suitcase"></i>
                <span slot="title">每刻往来单位</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="4" v-if="iuPost == 2 && iuId == 4">
              <template slot="title">
                <i class="el-icon-s-platform"></i>
                <span>系统监测</span>
              </template>
              <el-menu-item index="RosterHand" route="/Home/RosterHand">
                <i class="el-icon-monitor"></i>
                <span slot="title">线上花名册</span>
              </el-menu-item>
              <el-menu-item index="wxFeedBack" route="/Home/wxFeedBack">
                <i class="el-icon-suitcase"></i>
                <span slot="title">微信工具反馈</span>
              </el-menu-item>
              <el-menu-item index="wxColophon" route="/Home/wxColophon">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">微信工具版本记录</span>
              </el-menu-item>
              <el-menu-item index="wxMemoryBaseAddress" route="/Home/wxMemoryBaseAddress">
                <i class="el-icon-school"></i>
                <span slot="title">微信版本内存基址</span>
              </el-menu-item>
              <el-menu-item index="wxErrorLog" route="/Home/wxErrorLog">
                <i class="el-icon-chat-line-square"></i>
                <span slot="title">微信工具错误日志</span>
              </el-menu-item>
              <el-menu-item index="wxToolLog" route="/Home/wxToolLog">
                <i class="el-icon-chat-line-square"></i>
                <span slot="title">微信工具日志</span>
              </el-menu-item>
            </el-submenu>
            <!-- <el-menu-item index="errorApi" route="/Home/errorApi" v-if="iuId == 4">
              <i class="el-icon-question"></i>
              <span slot="title">异常报错</span>
            </el-menu-item> -->
            <el-menu-item index="SystemLog" route="/Home/SystemLog">
              <i class="el-icon-info"></i>
              <span slot="title">系统日志</span>
            </el-menu-item>
          </el-menu>
        </div>

        <div id="main">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
      </div>
    </div>
    <el-dialog :title="conterstr.noticeTitle" :visible.sync="Isconter" width="70%" top="8vh">
      <div style="margin: 15px;">
        {{ conterstr.noticeContent }}
      </div>
      <p style="margin: 15px;">通知时间:{{ conterstr.createtime }}</p>
    </el-dialog>
    <el-dialog title="消息列表" :visible.sync="IsConterShow" width="70%" top="8vh">
      <div style="width: 100%">
        <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
          :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
          :checkbox-option="checkboxOption" row-key-field-name="dataIndex" :cellSelectionOption="cellSelectionOption"
          style="width: 100%" />
        <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
      </div>
      <div class="table-pagination">
        <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
          :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
          @on-page-size-change="pageSizeChange" />
      </div>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="updataPw" width="25%" center>
      <p>新密码</p>
      <el-input v-model="suPw" autocomplete="off"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="updataPw = false; suPw = ''">取 消</el-button>
        <el-button type="primary" @click="updataPwclick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getIvNoticeList, getIvNoticeUnReadNum, deleteIvNoticeRead, updateIvNoticeRead, updateIvUserPw
} from "../api/api";
export default {
  name: "Home",
  data() {
    return {
      iuId: '',
      suPw: '',
      updataPw: false,
      formDatas: {
        currentPage: 1,
        pageSize: 10,
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },

        {
          field: "noticeTitle",
          key: "noticeTitle",
          title: "标题",
          align: "center",
          width: 200,

        },
        {
          field: "noticeContent",
          key: "noticeContent",
          title: "内容",
          align: "center",


        },
        {
          field: "createtime",
          key: "createtime",
          title: "通知时间",
          align: "center",
          width: 200,

        },
        {
          field: "",
          key: "d",
          title: "操作",
          width: 200,
          fixed: 'right',
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {
                  row.noticeStatus == 1 ? <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.getRead(row)}
                  >
                    已读
                  </el-button> : ''
                }

                <el-button
                  size="mini"
                  type="text"
                  style="color: red"
                  on-click={() => this.deleteRead(row.noticeId)}
                >
                  删除
                </el-button>

              </span>
            );
          },
        }
      ],
      cellSelectionOption: {
        // disble cell selection
        enable: true,
      },
      totalCount: 100,
      pageIndex: 1,
      pageSize: 10,
      selectedRowKeysCollection: [],
      checkboxOption: {
        // 可控属性
        selectedRowKeys: [],
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.changeSelectedRowKeys(row, isSelected);
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.changeSelectAll(isSelected, selectedRowKeys);
        },
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      tableDataCopy: [],
      tableHight: 520,
      tableData: [],
      IsConterShow: false,

      flag: '',
      flagShow: false,
      iuPost: '',
      Isconter: false,
      conterstr: '',
      post: localStorage.getItem("post"),
      iuId: localStorage.getItem("iuId"),
      username: "",
      readNUmArr: [],
      readNUm: '',
      isCollapse: false,
    };
  },
  created() {
    //console.log("首页");
    this.iuId = localStorage.getItem("iuId");
    this.username = localStorage.getItem("iuName");
    document.title = "傲举招聘管理系统";
    this.iuPost = localStorage.getItem("iuPost");
    this.flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    //console.log(this.flag);
    if (this.flag) {
      this.flagShow = true;
      
      // this.$router.replace('/Home/recordingh5')
    }
   
    this.partserch();
    getIvNoticeUnReadNum().then(res => {
      if (res.data == 0) {
        this.readNUm = '';
        return
      }
      this.readNUm = res.data
    })
  },
  watch: {},

  activated() {
    this.username = localStorage.getItem("iuName");
    document.title = "傲举招聘管理系统";
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
    "$store.state.HomeNum"(val) {
      this.$nextTick(() => {
        this.getlist()
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
    this.IsConterShow = false
  },
  methods: {
    updataPwclick() {
      if (this.suPw == '') {
        this.$message({
          type: 'warning',
          message: '请输入密码!'
        })
      } else {
        updateIvUserPw({ iuPw: this.suPw }).then(res => {
          this.$message({
            type: 'success',
            message: '修改成功!'
          })
          this.updataPw = false;
          this.suPw = '';

        })
      }
    },
    handleCommand(command) {
      if (command == "a") {
        this.Out()
      } else {
        this.updataPw = true;
      }
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.formDatas.checkStatus = 2;
      getIvNoticeList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.tableDataCopy = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys();

      });
      getIvNoticeUnReadNum().then(res => {
        if (res.data == 0) {
          this.readNUm = ''
          return
        }
        this.readNUm = res.data

      })
    },
    resetSelectedRowKeys() {
      //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
      this.checkboxOption.selectedRowKeys = [];

      const selectedRowKeysCollection = this.selectedRowKeysCollection;

      if (selectedRowKeysCollection.length) {
        this.tableData.forEach((item) => {
          if (selectedRowKeysCollection.indexOf(item.auId) > -1) {
            //console.log(item);
            this.checkboxOption.selectedRowKeys.push(item.auId);
          }
        });
      }
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.partserch();
    },
    pageNumberChange(pageIndex) {
      //console.log(pageIndex);
      this.formDatas.currentPage = pageIndex;
      this.formDatas.checkStatus = 2;
      getIvNoticeList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.tableDataCopy = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys();
        // this.$message({
        //     type: "success",
        //     message: "搜索成功!",
        // });
      });

    },
    getRead(val) {
      // this.conterstr = val;
      // this.Isconter = true;
      if (val.noticeStatus == 1) {
        updateIvNoticeRead({ noticeIds: val.noticeId }).then(res => {
          this.partserch()
        })
      }
    },
    getlist() {
      getIvNoticeList().then(res => {
        //console.log(res.data);
        this.readNUmArr = res.data
      })
      getIvNoticeUnReadNum().then(res => {
        if (res.data == 0) {
          this.readNUm = ''
          return
        }
        this.readNUm = res.data

      })
    },
    deleteRead(id) {
      this.$confirm("是否确定要删除通知吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteIvNoticeRead({ noticeIds: id }).then(res => {
            this.partserch()
          })

        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })
    },
    Out() {
      localStorage.clear();
      this.$router.push({
        path: "/doLogin",
      });
    },
    handleOpen(key, keyPath) {
    },


    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
  },
};
</script>

<style scoped="scoped">
.item {
  position: absolute;
  top: 5px;
  right: 20px;
  margin-top: 15px;
  margin-right: 20px;
}

#entirety {
  width: 100%;
  height: 100vh;
}

#headNav {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #121212;
  display: flex;
  justify-content: space-between;
}

.scrollHidden {
  overflow-y: scroll;
}

.head_text {
  color: white;
  margin-left: 2em;
  font-size: 19px;
  margin-left: 2%;
  width: 45%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#sideNav {
  /* width: 13%; */
  height: 100%;
  background-color: #121212;
  overflow-y: scroll;
  overflow-x: hidden;
}

#main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 230px;
  min-height: 400px;
}

div /deep/ .el-submenu__icon-arrow {
  right: 40px;
}

/* 隐藏滚动条 */
.scrollHidden::-webkit-scrollbar {
  display: none;
}
</style>
